module.exports = function mapArrayCoordsToGeolib(coords) {
  return {
    latitude: coords[0],
    longitude: coords[1],
  };
};
